import { render, staticRenderFns } from "./EditSie.vue?vue&type=template&id=4ff7e2f6&scoped=true&"
import script from "./EditSie.vue?vue&type=script&lang=ts&"
export * from "./EditSie.vue?vue&type=script&lang=ts&"
import style0 from "./EditSie.vue?vue&type=style&index=0&id=4ff7e2f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff7e2f6",
  null
  
)

export default component.exports